import { create } from 'zustand'

type HeaderVariant = 'default' | 'minimal';

interface HeaderStore {
  variant: HeaderVariant;
  setVariant: (variant: HeaderVariant) => void;
}

export const useHeaderStore = create<HeaderStore>((set) => ({
  variant: 'default',
  setVariant: (variant) => set({ variant }),
}))
